import { useCallback } from 'react';
import { message } from 'antd';
import useDeleteShoppingItemMutation from '../../../../queries/useDeleteShoppingItemMutation';
import { CartTableItem } from '../../../../types/home';

export default function useDeleteCartItem(
  prepareData: (showPendingItems: boolean) => Promise<void>,
  refetchShoppingCart: (params: {
    checkStatus: boolean;
    withPrice: boolean;
  }) => void
) {
  const deleteShoppingItemMutation = useDeleteShoppingItemMutation();

  const deleteItem = useCallback(
    async (item: CartTableItem) => {
      try {
        const response = await deleteShoppingItemMutation.mutateAsync(
          item.orderId
        );
        if (response) {
          await prepareData(true);
          refetchShoppingCart({ checkStatus: false, withPrice: true });
        } else {
          message.error('Failed to remove!');
        }
      } catch (error) {
        message.error('Failed to remove!');
      }
    },
    [deleteShoppingItemMutation, prepareData]
  );

  return {
    deleteItem,
    isDeleting: deleteShoppingItemMutation.isPending,
  };
}
